import { render, staticRenderFns } from "./DeleteFileModal.vue?vue&type=template&id=b5fbf768&scoped=true"
import script from "./DeleteFileModal.vue?vue&type=script&lang=js"
export * from "./DeleteFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fbf768",
  null
  
)

export default component.exports